import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, palette }: Theme) => ({
  coloredSection: {
    padding: '2rem 0',
    backgroundColor: palette.secondary.light,
    [breakpoints.up('sm')]: {
      padding: '4rem 0',
    },
  },
  simulator: {
    marginBottom: '2rem',
    [breakpoints.up('sm')]: {
      marginBottom: '4rem',
    },
  },
  veeva: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: palette.grey[200],
    fontSize: '0.625rem',
    lineHeight: 1.1,
  },
}));
